import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class RelaunchCloudConnector {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(): Promise<{ [key: string]: string; }> {
    let args = {
    }
    let res = this.dispatcher.dispatch('invoices.relaunch.cloud.connector', args)
    return res
  }
}